import { render, staticRenderFns } from "./FooterVersionInfo.vue?vue&type=template&id=290c3e95&"
import script from "./FooterVersionInfo.vue?vue&type=script&lang=js&"
export * from "./FooterVersionInfo.vue?vue&type=script&lang=js&"
import style0 from "./FooterVersionInfo.vue?vue&type=style&index=0&id=290c3e95&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports